import cn from 'classnames';
import React from 'react';
import styled from 'styled-components';
import { Core } from 'connex-cds';
import { BuildQrCode } from './BuildQrCode';
import { useQrSummary } from './QrSummaryProvider';

const Styled = styled.div`
  display: flex;
  justify-content: center;
`;

const QRCode = () => {
  const { summaryRef, loading, isReadyToSync, syncQrSummary } = useQrSummary();

  // Opening this tab is what picks up ticket edits, since the write path is otherwise gated on batch
  // data changing. Wait until pdfContext has resolved so customerJob / watermarks are not stored blank.
  const hasSynced = React.useRef(false);

  React.useEffect(() => {
    if (hasSynced.current || !isReadyToSync) {
      return;
    }

    hasSynced.current = true;
    syncQrSummary?.();
  }, [isReadyToSync, syncQrSummary]);

  return (
    <Styled className={cn('qr-tab')}>
      <Core.Spinner spin={loading}>
        <BuildQrCode summaryRef={summaryRef} />
      </Core.Spinner>
    </Styled>
  );
};

export default QRCode;
